import { Container, Row, Col } from 'react-bootstrap';
import "../media/Media.css"

import backgroundImage from "../../assets/images/slide2.jpeg";
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { useEffect, useState } from 'react';

const Pagination = ({ hasNext, setPage, page }) => {
    const handlePrev = () => {

        if (page > 1) {
            setPage(page - 1);
        }

    };

    const handleNext = () => {
        setPage(page + 1);
    };
    return (
        <>
            <div className="d-flex justify-content-center mt-3">
                <button
                    onClick={handlePrev}
                    disabled={page === 1}
                    className="btn btn-danger mx-2">
                    Prev
                </button>
                <button
                    onClick={handleNext}
                    disabled={hasNext === false}
                    className="btn btn-danger mx-2" >
                    Next
                </button>
            </div>

        </>
    )
}


const Media = () => {

    const [page, setPage] = useState(1);
    const [hasNext, setHasNext] = useState(false);
    const [media, setMedia] = useState([]);

    const sectionStyle = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#a20000',
        backgroundBlendMode: 'multiply',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '250px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };




    useEffect(() => {
        const getMedia = async () => {
            try {

                let res = await axios.get(`https://gautamsolar.us/media?page=${page}`);
                if (res?.data?.success) {
                    setHasNext(res?.data?.hasNext);
                    setMedia(res?.data?.media);
                }

            } catch (er) {
                console.log(er?.message);
            }
        }
        getMedia();

    }, [page])

    return (
        <>
            <Helmet>
                <title>Top Leaders Of Solar Industry</title>
                <meta name="description" content="Uncover India’s top solar industry leaders like Gautam Solar. With twin factories in Haridwar and Bhiwani, patents, fully automated production, and specialised modules, they serve as pillars of innovation. " />
                <meta name="keywords" content="Top Leaders Of Solar Industry, best quality solar panels, solar panel manufacturers in india, buy solar panel for home" />
                
                <link rel="canonical" href="https://gautamsolar.com/media/" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "@id": "https://gautamsolar.com/media/#webpage",
                        url: "https://gautamsolar.com/media/",
                        name: "Media Coverage | Gautam Solar",
                        description:
                            "Media coverage and press mentions of Gautam Solar, a leading Indian solar module manufacturer with facilities in Haridwar and Bhiwani.",
                        inLanguage: "en",
                        publisher: {
                            "@type": "Organization",
                            name: "Gautam Solar",
                            url: "https://gautamsolar.com/",
                        },
                        breadcrumb: {
                            "@id": "https://gautamsolar.com/media/#breadcrumb",
                        },
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "@id": "https://gautamsolar.com/media/#breadcrumb",
                        itemListElement: [
                            { "@type": "ListItem", position: 1, name: "Home", item: "https://gautamsolar.com/" },
                            { "@type": "ListItem", position: 2, name: "Media", item: "https://gautamsolar.com/media/" },
                        ],
                    })}
                </script>
            </Helmet>

            <h1 className='sr-only'>Thought Leaders Of Solar Industry</h1>

            <section
                className="elementor-section elementor-top-section elementor-element elementor-element-d29e141 elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default"
                data-id="d29e141"
                data-element_type="section"
                data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
                style={{ ...sectionStyle }}
            >
                <div className="elementor-background-overlay"></div>
                <Container className="elementor-container elementor-column-gap-no">
                    <Row className="elementor-row">
                        <Col className="elementor-column elementor-col-12 elementor-top-column elementor-element elementor-element-0a1c64f" data-id="0a1c64f" data-element_type="column">
                            <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                    <div
                                        className="elementor-element elementor-element-b12b60d elementor-widget elementor-widget-modina_section_title"
                                        data-id="b12b60d"
                                        data-element_type="widget"
                                        data-widget_type="modina_section_title.default"
                                    >
                                        <div className="elementor-widget-container">
                                            <div className="block-contents text-center">
                                                <h2 className='resText lh-1'>Thought Leaders Of Solar Industry</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>

            <div className="container my-5">
                <div className="row g-4">
                    {media.length > 0 && media.map((item) => (
                        <div className="col-12 col-md-4" key={item?._id}>
                            <div
                                style={{
                                    borderRadius: "10px",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                    overflow: "hidden",
                                    textAlign: "center",
                                    background: "#fff",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                }}
                            >
                                <a href={item?.mediaLink} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={item?.mediaImg}
                                        alt={item?.mediaTitle}
                                        style={{
                                            height: "150px",
                                            objectFit: "contain",
                                            width: "100%",
                                            background: "#f9f9f9",
                                            padding: "10px",
                                        }}
                                    />
                                </a>
                                <div style={{ padding: "15px", flexGrow: 1 }}>
                                    <h5
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            marginBottom: "8px",
                                            color: "#333",
                                        }}
                                    >
                                        {item?.mediaTitle}
                                    </h5>
                                    <p
                                        style={{
                                            fontSize: "13px",
                                            color: "#888",
                                            marginBottom: "12px",
                                        }}
                                    >
                                        {new Date(item?.createdAt).toDateString()}
                                    </p>
                                    <a
                                        className="btn btn-outline-danger"

                                        href={item?.mediaLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Learn More
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <Pagination
                    hasNext={hasNext}
                    setPage={setPage}
                    page={page}
                />
            </div>

        </>

    );
};

export default Media;
